import React from 'react';
import { func, string } from 'prop-types';
import styled, { css } from 'styled-components';
import { Flex, Typography, Icon } from '@atoms';
import { ReactComponent as Arrow } from '@assets/arrow-down.svg';

const Header = ({ title, onBackUpClick }) => (
  <Wrapper justifyCenter itemsCenter>
    <IconWrapper onClick={onBackUpClick}>
      <Icon SVG={Arrow} />
    </IconWrapper>
    <Typography weight="medium" size="xl4">{title}</Typography>
  </Wrapper>
);

const Wrapper = styled(Flex)`
  ${({ theme: { color } }) => css`
    width: 100%;
    height: 50px;
    position: sticky;
    top: 0;
    left: 0;
    background-color: ${color.white};
    border-bottom: 1px solid ${color.black};
    z-index: 1;
  `}
`;

const IconWrapper = styled(Flex)`
  ${({ theme: { color, spacing } }) => css`
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding: ${spacing.md};
    object-fit: contain;

    ${Icon} {
      height: 100%;
      width: auto;
      transform: rotate(90deg);
      fill: ${color.strawberry};
    }
  `}
`;

Header.propTypes = {
  title: string.isRequired,
  onBackUpClick: func.isRequired,
};

export default Header;
